// extracted by mini-css-extract-plugin
export default {"fetching-wrapper":"kleJQI0OYfeJOq1z5ujb","error-title":"WFATKaFyPa8pzWUHLLio","fetching":"FlFtmSQgH1fYEdFbBpjr","blinking-background":"HeYOzFJ7hSNhIpFlLkQy"};